<template>
    <div class="amap-container">
      <div class="map-wrapper">
        <div id="container" ref="mapContainer" class="map-container"></div>
        
        <!-- 控制面板 -->
        <div class="control-panel">
         
          
          <div class="location-controls">
            <button @click="getCurrentLocation" class="control-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="1"></circle>
                <line x1="12" y1="2" x2="12" y2="4"></line>
                <line x1="12" y1="20" x2="12" y2="22"></line>
                <line x1="2" y1="12" x2="4" y2="12"></line>
                <line x1="20" y1="12" x2="22" y2="12"></line>
              </svg>
              定位
            </button>
            
          </div>
        </div>
        
        <!-- 导航信息面板 -->
        <div v-if="routeInfo.visible" class="route-info">
          <div class="route-header">
            <h3>路线信息</h3>
            <button @click="routeInfo.visible = false" class="close-btn">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <div class="route-details">
            <div class="route-item">
              <span class="label">总距离:</span>
              <span class="value">{{ routeInfo.distance }}</span>
            </div>
            <div class="route-item">
              <span class="label">预计时间:</span>
              <span class="value">{{ routeInfo.duration }}</span>
            </div>
            <div v-if="routeInfo.toll" class="route-item">
              <span class="label">过路费:</span>
              <span class="value">{{ routeInfo.toll }}</span>
            </div>
          </div>
          <div class="route-steps">
            <h4>行驶指南</h4>
            <div v-for="(step, index) in routeInfo.steps" :key="index" class="step-item">
              <span class="step-number">{{ index + 1 }}</span>
              <span class="step-instruction" v-html="step"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  // 高德地图 API 密钥
  const API_KEY = '	bfc8d79833649fc4ad88c16b5a55e5c8'; // 替换为您的高德地图 API 密钥
  
  // 响应式数据
  const mapContainer = ref(null);
  const map = ref(null);
  const geolocation = ref(null);
  const driving = ref(null);
  const currentPosition = ref(null);

  const markers = ref([]);
  const routeInfo = ref({
    visible: false,
    distance: '',
    duration: '',
    toll: '',
    steps: []
  });
  
  // 计算属性

  
  // 加载高德地图 API
  const loadAMapAPI = () => {
    return new Promise((resolve, reject) => {
      if (window.AMap) {
        resolve(window.AMap);
        return;
      }
  
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://webapi.amap.com/maps?v=2.0&key=${API_KEY}&plugin=AMap.Geolocation,AMap.Driving,AMap.PlaceSearch,AMap.ToolBar,AMap.Scale,AMap.HawkEye,AMap.MapType`;
      script.onerror = reject;
      script.onload = () => {
        resolve(window.AMap);
      };
      document.head.appendChild(script);
    });
  };
  
  // 初始化地图
  const initMap = async () => {
    try {
      const AMap = await loadAMapAPI();
      
      // 创建地图实例
      map.value = new AMap.Map(mapContainer.value, {
        zoom: 13,
        viewMode: '3D',
        resizeEnable: true,
        rotateEnable: true,
        pitchEnable: true,
        buildingAnimation: true,
      });
      
      // 添加控件
      map.value.addControl(new AMap.ToolBar());
      map.value.addControl(new AMap.Scale());
      map.value.addControl(new AMap.HawkEye({isOpen: false}));
      map.value.addControl(new AMap.MapType());
      
      // 初始化定位插件
      geolocation.value = new AMap.Geolocation({
        enableHighAccuracy: true,
        timeout: 10000,
        zoomToAccuracy: true,
        buttonPosition: 'RB'
      });
      
      // 初始化驾车导航插件
      driving.value = new AMap.Driving({
        policy: AMap.DrivingPolicy.LEAST_TIME,
        map: map.value
      });
      
      // 自动定位
      getCurrentLocation();
      
    } catch (error) {
      console.error('初始化地图失败:', error);
      alert('地图加载失败，请检查网络连接或刷新页面重试');
    }
  };
  
  // 获取当前位置
  const getCurrentLocation = () => {
    if (!geolocation.value) return;
    
    geolocation.value.getCurrentPosition((status, result) => {
      if (status === 'complete') {
        currentPosition.value = result.position;
        
        // 添加当前位置标记
        addMarker(currentPosition.value, '当前位置', 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png');
        
        // 移动地图到当前位置
        map.value.setCenter(currentPosition.value);
      } else {
        console.error('定位失败:', result);
        alert('获取位置失败: ' + result.message);
      }
    });
  };

  // 搜索位置
  
  
  // 添加标记
  const addMarker = (position, title, icon) => {
    const marker = new AMap.Marker({
      position,
      title,
      icon: icon || 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
      animation: 'AMAP_ANIMATION_DROP'
    });
    
    map.value.add(marker);
    markers.value.push(marker);
    
    // 添加信息窗体
    const infoWindow = new AMap.InfoWindow({
      content: `<div style="padding: 8px;">${title}</div>`,
      offset: new AMap.Pixel(0, -30)
    });
    
    marker.on('click', () => {
      infoWindow.open(map.value, marker.getPosition());
    });
  };
  
  // 开始导航
  
  
  // 格式化距离
 
  
  // 生命周期钩子
  onMounted(() => {
    initMap();
  });
  
  onUnmounted(() => {
    // 销毁地图实例
    if (map.value) {
      map.value.destroy();
    }
  });
  </script>
  
  <style scoped>
  .amap-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .map-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }
  
  .map-container {
    width: 100%;
    height: 100%;
    min-height: 500px;
    max-width: 100%;
  }
  
  .control-panel {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 100;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    padding: 10px;
    width: 300px;
  }
  
  .search-box {
    display: flex;
    margin-bottom: 10px;
  }
  
  .destination-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
  }
  
  .search-btn {
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 0 4px 4px 0;
    padding: 0 15px;
    cursor: pointer;
  }
  
  .location-controls {
    display: flex;
    justify-content: space-between;
  }
  
  .control-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s;
  }
  
  .control-btn:hover {
    background-color: #f5f5f5;
  }
  
  .control-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .route-info {
    position: absolute;
    bottom: 20px;
    right: 20px;
    z-index: 100;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    width: 300px;
    max-height: 400px;
    overflow-y: auto;
  }
  
  .route-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
  }
  
  .route-header h3 {
    margin: 0;
    font-size: 16px;
  }
  
  .close-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
  }
  
  .route-details {
    padding: 10px 15px;
    border-bottom: 1px solid #eee;
  }
  
  .route-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  
  .label {
    color: #666;
  }
  
  .value {
    font-weight: bold;
  }
  
  .route-steps {
    padding: 10px 15px;
  }
  
  .route-steps h4 {
    margin: 0 0 10px 0;
    font-size: 14px;
  }
  
  .step-item {
    display: flex;
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #eee;
  }
  
  .step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background-color: #1890ff;
    color: white;
    border-radius: 50%;
    margin-right: 10px;
    flex-shrink: 0;
    font-size: 12px;
  }
  
  .step-instruction {
    flex: 1;
    font-size: 13px;
    line-height: 1.5;
  }
  
  @media (max-width: 768px) {
    .control-panel {
      width: calc(100% - 20px);
    }
    
    .route-info {
      width: calc(100% - 40px);
      left: 20px;
      right: 20px;
    }
  }
  </style>